import { gql } from '@apollo/client';

export const DIGITAL_DOCUMENT = gql`
  query DigitalDocumentURL($digitalDocumentKey: String!) {
    digitalScoreReportURL(digitalDocumentKey: $digitalDocumentKey)
  }
`;
